import i from './user-list.container';

export default i;
